import { FORM_FIELD } from '@/constants/constants';
const APP_CONFIG = {
  monday_constants: {
    column_types: {
      status: 'status',
      formula: 'formula',
    },
  },
  prefilled_fields_types: [
    'date',
    'long_text',
    'text',
    'location',
    'numbers',
    'item_id',
    'phone',
    'email',
    'mirror',
    'formula',
    'status',
    'dropdown',
    'board_relation',
  ],
  signature_field_types: [
    'Receiver Signature',
    'Receiver Initials',
    'Sender Signature',
    'Sender Initials',
    'Signature',
    'Initials',
  ],
  form_fields: {
    lineItem: {
      title: 'Line Items',
      id: 'line-item',
    },
    checkbox: {
      title: 'Checkbox',
      id: 'checkbox',
    },
    textBox: {
      title: 'Text Box',
      id: 'text-box',
    },
    textArea: {
      title: 'Text Area',
      id: 'sd-textarea',
    },
    dropdown: {
      title: 'Dropdown',
      id: 'sd-dropdown',
    },
    signDate: {
      id: 'sign-date',
      title: 'Sign Date',
    },
    receiverSignature: {
      id: 'receiver-signature',
      title: 'Receiver Signature',
    },
    receiverInitials: {
      id: 'receiver-initials',
      title: 'Receiver Initials',
    },
    senderSignature: {
      id: 'sender-signature',
      title: 'Sender Signature',
    },
    signatureField: {
      id: 'signature-field',
      title: 'Signature',
    },
    initialsField: {
      id: 'initials-field',
      title: 'Initials',
    },
    senderInitials: {
      id: 'sender-initials',
      title: 'Sender Initials',
    },
    itemName: {
      id: 'item-name',
      title: 'Item Name',
    },
    image: { id: 'sd-image', title: 'Image' },
    payment: { id: 'sd-payment', title: 'Payment Item' },
    link: { id: 'sd-link', title: 'Link' },
    standard_fields: {
      checkbox: {
        title: 'Checkbox',
        id: 'checkbox',
      },
      textBox: {
        title: 'Text Box',
        id: 'text-box',
      },
      dropdown: {
        title: 'Dropdown',
        id: 'sd-dropdown',
      },
      receiverSignature: {
        id: 'receiver-signature',
        title: 'Receiver Signature',
      },
      receiverInitials: {
        id: 'receiver-initials',
        title: 'Receiver Initials',
      },
      senderSignature: {
        id: 'sender-signature',
        title: 'Sender Signature',
      },
      senderInitials: {
        id: 'sender-initials',
        title: 'Sender Initials',
      },
      signatureField: {
        id: 'signature-field',
        title: 'Signature',
      },
      initialsField: { id: 'initials-field', title: 'Initials' },
      payment: { id: 'sd-payment', title: 'Payment Item' },
      datePicker: {
        id: 'sd-datepicker',
        title: 'Date Picker',
      },
      signDate: {
        id: 'sign-date',
        title: 'Sign Date',
      },
      fileUpload: {
        id: FORM_FIELD.FILE,
        title: 'File Upload',
      },
    },
  },
  // list of all the currency supported by stripe
  currencyList: [
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'AED', label: 'AED' },
    { value: 'AFN', label: 'AFN' },
    { value: 'ALL', label: 'ALL' },
    { value: 'AMD', label: 'AMD' },
    { value: 'ANG', label: 'ANG' },
    { value: 'AOA', label: 'AOA' },
    { value: 'ARS', label: 'ARS' },
    { value: 'AUD', label: 'AUD' },
    { value: 'AWG', label: 'AWG' },
    { value: 'AZN', label: 'AZN' },
    { value: 'BAM', label: 'BAM' },
    { value: 'BBD', label: 'BBD' },
    { value: 'BDT', label: 'BDT' },
    { value: 'BGN', label: 'BGN' },
    { value: 'BIF', label: 'BIF' },
    { value: 'BMD', label: 'BMD' },
    { value: 'BND', label: 'BND' },
    { value: 'BOB', label: 'BOB' },
    { value: 'BRL', label: 'BRL' },
    { value: 'BSD', label: 'BSD' },
    { value: 'BWP', label: 'BWP' },
    { value: 'BYN', label: 'BYN' },
    { value: 'BZD', label: 'BZD' },
    { value: 'CAD', label: 'CAD' },
    { value: 'CDF', label: 'CDF' },
    { value: 'CHF', label: 'CHF' },
    { value: 'CLP', label: 'CLP' },
    { value: 'CNY', label: 'CNY' },
    { value: 'COP', label: 'COP' },
    { value: 'CRC', label: 'CRC' },
    { value: 'CVE', label: 'CVE' },
    { value: 'CZK', label: 'CZK' },
    { value: 'DJF', label: 'DJF' },
    { value: 'DKK', label: 'DKK' },
    { value: 'DOP', label: 'DOP' },
    { value: 'DZD', label: 'DZD' },
    { value: 'EGP', label: 'EGP' },
    { value: 'ETB', label: 'ETB' },
    { value: 'FJD', label: 'FJD' },
    { value: 'FKP', label: 'FKP' },
    { value: 'GBP', label: 'GBP' },
    { value: 'GEL', label: 'GEL' },
    { value: 'GIP', label: 'GIP' },
    { value: 'GMD', label: 'GMD' },
    { value: 'GNF', label: 'GNF' },
    { value: 'GTQ', label: 'GTQ' },
    { value: 'GYD', label: 'GYD' },
    { value: 'HKD', label: 'HKD' },
    { value: 'HNL', label: 'HNL' },
    { value: 'HTG', label: 'HTG' },
    { value: 'HUF', label: 'HUF' },
    { value: 'IDR', label: 'IDR' },
    { value: 'ILS', label: 'ILS' },
    { value: 'INR', label: 'INR' },
    { value: 'ISK', label: 'ISK' },
    { value: 'JMD', label: 'JMD' },
    { value: 'JPY', label: 'JPY' },
    { value: 'KES', label: 'KES' },
    { value: 'KGS', label: 'KGS' },
    { value: 'KHR', label: 'KHR' },
    { value: 'KMF', label: 'KMF' },
    { value: 'KRW', label: 'KRW' },
    { value: 'KYD', label: 'KYD' },
    { value: 'KZT', label: 'KZT' },
    { value: 'LAK', label: 'LAK' },
    { value: 'LBP', label: 'LBP' },
    { value: 'LKR', label: 'LKR' },
    { value: 'LRD', label: 'LRD' },
    { value: 'LSL', label: 'LSL' },
    { value: 'MAD', label: 'MAD' },
    { value: 'MDL', label: 'MDL' },
    { value: 'MGA', label: 'MGA' },
    { value: 'MKD', label: 'MKD' },
    { value: 'MMK', label: 'MMK' },
    { value: 'MNT', label: 'MNT' },
    { value: 'MOP', label: 'MOP' },
    { value: 'MUR', label: 'MUR' },
    { value: 'MVR', label: 'MVR' },
    { value: 'MWK', label: 'MWK' },
    { value: 'MXN', label: 'MXN' },
    { value: 'MYR', label: 'MYR' },
    { value: 'MZN', label: 'MZN' },
    { value: 'NAD', label: 'NAD' },
    { value: 'NGN', label: 'NGN' },
    { value: 'NIO', label: 'NIO' },
    { value: 'NOK', label: 'NOK' },
    { value: 'NPR', label: 'NPR' },
    { value: 'NZD', label: 'NZD' },
    { value: 'PAB', label: 'PAB' },
    { value: 'PEN', label: 'PEN' },
    { value: 'PGK', label: 'PGK' },
    { value: 'PHP', label: 'PHP' },
    { value: 'PKR', label: 'PKR' },
    { value: 'PLN', label: 'PLN' },
    { value: 'PYG', label: 'PYG' },
    { value: 'QAR', label: 'QAR' },
    { value: 'RON', label: 'RON' },
    { value: 'RSD', label: 'RSD' },
    { value: 'RUB', label: 'RUB' },
    { value: 'RWF', label: 'RWF' },
    { value: 'SAR', label: 'SAR' },
    { value: 'SBD', label: 'SBD' },
    { value: 'SCR', label: 'SCR' },
    { value: 'SEK', label: 'SEK' },
    { value: 'SGD', label: 'SGD' },
    { value: 'SHP', label: 'SHP' },
    { value: 'SLE', label: 'SLE' },
    { value: 'SOS', label: 'SOS' },
    { value: 'SRD', label: 'SRD' },
    { value: 'STD', label: 'STD' },
    { value: 'SZL', label: 'SZL' },
    { value: 'THB', label: 'THB' },
    { value: 'TJS', label: 'TJS' },
    { value: 'TOP', label: 'TOP' },
    { value: 'TRY', label: 'TRY' },
    { value: 'TTD', label: 'TTD' },
    { value: 'TWD', label: 'TWD' },
    { value: 'TZS', label: 'TZS' },
    { value: 'UAH', label: 'UAH' },
    { value: 'UGX', label: 'UGX' },
    { value: 'UYU', label: 'UYU' },
    { value: 'UZS', label: 'UZS' },
    { value: 'VND', label: 'VND' },
    { value: 'VUV', label: 'VUV' },
    { value: 'WST', label: 'WST' },
    { value: 'XAF', label: 'XAF' },
    { value: 'XCD', label: 'XCD' },
    { value: 'XOF', label: 'XOF' },
    { value: 'XPF', label: 'XPF' },
    { value: 'YER', label: 'YER' },
    { value: 'ZAR', label: 'ZAR' },
    { value: 'ZMW', label: 'ZMW' },
  ],
  pricingPlans: {
    free: 'gs_free',
    starter: 'gs_starter_30',
    basic: 'gs_basic_55',
    standard: 'gs_standard_85',
    pro: 'gs_pro_115',
    enterprise: 'gs_enterprise_145',
    gs_enterprise_m: 'gs_enterprise_m',
    gs_enterprise_l: 'gs_enterprise_l',
    gs_enterprise_xl: 'gs_enterprise_xl',
    gs_enterprise_xxl: 'gs_enterprise_xxl',
  },
};

export default APP_CONFIG;
